import { render, staticRenderFns } from "./GMultiCheckboxTwoLines.vue?vue&type=template&id=121a352a&scoped=true&"
import script from "./GMultiCheckboxTwoLines.vue?vue&type=script&lang=ts&"
export * from "./GMultiCheckboxTwoLines.vue?vue&type=script&lang=ts&"
import style0 from "./GMultiCheckboxTwoLines.vue?vue&type=style&index=0&id=121a352a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a352a",
  null
  
)

export default component.exports